// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"430abc48","166":"65e441f2","267":"a37c5f61","375":"efa808a4","536":"96fedcce","609":"065a2a3a","693":"b2819c8a","730":"d557beff"}[chunkId] + ".chunk.js";
};